var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPurchaseDoneIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 139,
    height: 149,
    viewBox: "0 0 139 149",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "skii8frfda",
    width: "128.2%",
    height: "150%",
    x: "-14.1%",
    y: "-25%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.498 0 0 0 0 0.812 0 0 0 0 0.831 0 0 0 0.3 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "n6hjza0hic",
    width: "170%",
    height: "170%",
    x: "-35%",
    y: "-25%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.847862766 0 0 0 0 0.878042497 0 0 0 0 0.879868659 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "i5akvad2md",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "ibumdczghb",
    d: "M8.68 7.318l64.456-.026c2.762-.002 5.001 2.236 5.002 4.998v.007l-.032 31.97c-.003 2.758-2.24 4.993-4.998 4.994l-65.459.027c-2.209 0-4-1.79-4.001-3.998v-.006l.034-32.971C3.684 9.554 5.92 7.319 8.68 7.318z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E5F2F3",
    d: "M111.5 27c15.188 0 27.5 11.193 27.5 25s-12.312 25-27.5 25c-.524 0-1.045-.013-1.562-.04-.336.027-.68.04-1.031.04-12.6 0-19.565 5.85-20.907 15.5 0 19.054-19.252 34.5-43 34.5S2 111.554 2 92.5C2 73.446 21.252 58 45 58c7.422 0 14.405 1.509 20.498 4.165C75.216 64.92 84 61.12 84 53.834c0-.23.01-.452.03-.666l-.015-.343c-.01-.274-.015-.549-.015-.825 0-13.807 12.312-25 27.5-25zm-43 12c5.799 0 10.5 4.253 10.5 9.5S74.299 58 68.5 58 58 53.747 58 48.5 62.701 39 68.5 39z",
    transform: "translate(-613 -174) translate(613 174) matrix(-1 0 0 1 141 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#963F00",
    fillRule: "nonzero",
    d: "M65.869 60.75c.118.007.212.094.232.206l.004.058-2.519 46c-.007.138-.125.243-.263.236-.118-.007-.213-.094-.232-.206l-.004-.058 2.518-46c.008-.138.126-.243.264-.236z",
    transform: "translate(-613 -174) translate(613 174)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BC8F4E",
    fillRule: "nonzero",
    d: "M93.357 65.849c.083-.11.24-.132.35-.048.092.07.122.19.081.292l-.033.058-31.058 41c-.084.11-.24.132-.35.048-.092-.07-.123-.19-.082-.292l.033-.058 31.059-41z",
    transform: "translate(-613 -174) translate(613 174)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#963F00",
    fillRule: "nonzero",
    d: "M95.848 35.893c.06-.125.208-.178.333-.119.104.05.158.16.14.269l-.02.064-33.578 71c-.059.125-.208.178-.333.119-.104-.05-.158-.16-.14-.269l.021-.064 33.577-71z",
    transform: "translate(-613 -174) translate(613 174)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4D2B8",
    fillRule: "nonzero",
    d: "M116.564 27.92c3.393-9.56.236-19.513-7.05-22.23-7.286-2.717-15.942 2.83-19.334 12.39-3.392 9.56-.236 19.513 7.05 22.23 7.286 2.717 15.942-2.83 19.334-12.39z",
    transform: "translate(-613 -174) translate(613 174)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M53.68 45.895c.69-9.853 7.522-17.405 15.26-16.868 7.737.537 13.45 8.96 12.76 18.814-.691 9.854-7.523 17.406-15.26 16.868l-.128-.01 1.628 3.372c.105.22.07.472-.092.662-.162.19-.427.29-.695.262l-4.488-.488c-.268-.028-.5-.182-.605-.401-.106-.22-.07-.473.093-.663l2.558-2.99c-6.84-1.571-11.668-9.454-11.03-18.558z",
    transform: "translate(-613 -174) translate(613 174)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7FCFD4",
    fillRule: "nonzero",
    d: "M88.22 41.053c4.816-9.933 15.503-14.672 23.871-10.585 8.368 4.087 11.247 15.453 6.43 25.385-4.815 9.933-15.503 14.672-23.87 10.585l.237.113-.172 2.745c-.016.27-.161.51-.38.628-.22.118-.479.097-.68-.056l-3.357-2.518c-.2-.15-.314-.409-.297-.678.017-.268.162-.507.38-.624l1.927-1.044c-6.525-4.91-8.425-15.01-4.09-23.951zM91.196 19.131C92.619 9.818 87.472 1.313 79.698.136 71.925-1.041 64.47 5.555 63.046 14.869c-1.424 9.313 3.724 17.818 11.498 18.995 7.773 1.177 15.229-5.419 16.652-14.733z",
    transform: "translate(-613 -174) translate(613 174)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BC8F4E",
    fillRule: "nonzero",
    d: "M57.439 40.751c.117-.01.223.063.26.17l.01.057 5.877 66c.012.137-.09.259-.227.271-.118.01-.224-.063-.26-.17l-.011-.057-5.876-66c-.013-.137.089-.259.227-.271z",
    transform: "translate(-613 -174) translate(613 174)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BC8F4E",
    fillRule: "nonzero",
    d: "M78.52 54.761c.113.035.183.142.176.256l-.01.056-15.95 52c-.04.132-.18.206-.312.166-.113-.035-.184-.142-.176-.256l.01-.056 15.95-52c.034-.113.142-.184.255-.177l.057.011z",
    transform: "translate(-613 -174) translate(613 174)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33B4BC",
    fillRule: "nonzero",
    d: "M71.864 36.66c2.666-8.745 10.125-14.232 16.662-12.258 6.536 1.975 9.674 10.664 7.01 19.408-2.575 8.444-9.62 13.85-15.987 12.434l.431 1.816c.063.267-.024.547-.226.734-.203.187-.491.253-.756.173l-4.447-1.332c-.265-.08-.468-.293-.53-.56-.064-.267.022-.547.225-.734l1.81-1.675c-4.561-3.303-6.439-10.636-4.192-18.007z",
    transform: "translate(-613 -174) translate(613 174)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4D2B8",
    fillRule: "nonzero",
    d: "M54.138 3.047c9.282-.756 17.521 7.63 18.403 18.73.861 10.834-5.606 20.25-14.547 21.397l1.875 2.437c.151.199.173.454.058.671-.115.217-.35.363-.618.384l-4.493.332c-.27.019-.529-.092-.682-.29-.153-.199-.177-.455-.062-.673l1.467-2.758c-8.528-.378-15.785-8.383-16.61-18.762-.882-11.1 5.927-20.712 15.209-21.468z",
    transform: "translate(-613 -174) translate(613 174)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-613 -174) translate(613 174) translate(20.274 84.065) rotate(-168.76 40.894 28.29)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#skii8frfda)",
    xlinkHref: "#ibumdczghb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#7FCFD4",
    xlinkHref: "#ibumdczghb"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M30.951 9.51l41.97-.025c2.762-.001 5.002 2.236 5.003 4.997v.007l-.023 31.97c-.002 2.758-2.238 4.994-4.997 4.996l-42.97.025c-2.21.001-4.002-1.789-4.003-3.998v-.005l.023-32.97c.002-2.76 2.239-4.996 4.997-4.997z",
    transform: "translate(-613 -174) translate(613 174) translate(20.274 84.065) rotate(-168.76 51.928 30.482)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33B4BC",
    d: "M10.768 7.848L21.781 7.841 21.773 20.34 10.76 20.348z",
    transform: "translate(-613 -174) translate(613 174) translate(20.274 84.065) rotate(-168.76 16.27 14.094)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E5F2F3",
    d: "M1.006 2.011L17.591 2 17.586 11.125 1 11.136z",
    transform: "translate(-613 -174) translate(613 174) translate(20.274 84.065) translate(58.712 15.102) rotate(-168.76 9.296 6.568)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7FCFD4",
    d: "M12.263 4.125L16.012 4.123 16.007 10.752 12.258 10.754z",
    transform: "translate(-613 -174) translate(613 174) translate(20.274 84.065) translate(58.712 15.102) rotate(-168.76 14.135 7.439)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7FCFD4",
    d: "M2.756 2.785L12.124 2.779 12.124 4.042 2.755 4.048z",
    transform: "translate(-613 -174) translate(613 174) translate(20.274 84.065) translate(58.712 15.102) rotate(-168.76 7.44 3.414)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7FCFD4",
    d: "M2.331 4.904L11.7 4.898 11.699 6.161 2.331 6.167z",
    transform: "translate(-613 -174) translate(613 174) translate(20.274 84.065) translate(58.712 15.102) rotate(-168.76 7.015 5.532)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7FCFD4",
    d: "M4.793 22.837C2.147 22.837 0 20.683 0 18.029c0-2.655 2.147-4.808 4.793-4.808 2.647 0 4.793 2.153 4.793 4.808 0 2.654-2.146 4.808-4.793 4.808z",
    transform: "translate(-613 -174) translate(613 174) translate(0 35)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BC8F4E",
    d: "M19.172 22.837c0 1.328-1.072 2.403-2.396 2.403-1.324 0-2.397-1.075-2.397-2.403 0-1.329 1.073-2.404 2.397-2.404 1.324 0 2.396 1.075 2.396 2.404",
    transform: "translate(-613 -174) translate(613 174) translate(0 35)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4D2B8",
    d: "M9.586 2.404c0 1.328-1.072 2.404-2.396 2.404-1.324 0-2.397-1.076-2.397-2.404C4.793 1.076 5.866 0 7.19 0c1.324 0 2.396 1.076 2.396 2.404",
    transform: "translate(-613 -174) translate(613 174) translate(0 35)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-613 -174) translate(613 174) translate(115 69)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#n6hjza0hic)",
    xlinkHref: "#i5akvad2md"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#DDC6A6",
    xlinkHref: "#i5akvad2md"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.874 6.235c.168-.084.168-.317 0-.402L.279.02C.151-.042 0 .049 0 .188L.004 4.47c0 .667.557 1.21 1.245 1.21l3.154.332-3.154.314C.562 6.323.005 6.862.006 7.529l.003 4.282c0 .139.15.23.28.17l11.585-5.746z",
    transform: "translate(-613 -174) translate(613 174) translate(115 69) rotate(-45 12.121 1.464)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F4EE",
    d: "M11.875 6.237c.077-.038.119-.108.125-.18.005-.057-2.528-.071-7.6-.042l-3.156.313C.556 6.326-.001 6.864 0 7.53l.003 4.28c0 .139.15.23.28.17l11.592-5.744z",
    transform: "translate(-613 -174) translate(613 174) translate(115 69) rotate(-45 12.121 1.464)"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPurchaseDoneIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/purchaseDoneIcon.38ec7fb460fdc0a476724b51734df77e.svg";